/**
 * ThemeContext - 主题上下文提供器
 * 提供只读主题状态（配置驱动模式）
 * 
 * 主题通过环境变量 VITE_THEME 在构建时确定，无需运行时切换
 */

import React, { createContext, useEffect, useMemo } from 'react';
import { THEMES, CURRENT_THEME, applyTheme } from '../config/themeConfig';
import themes from '../config/themes';

// 创建主题上下文
export const ThemeContext = createContext(null);

/**
 * ThemeProvider 组件
 * 包裹应用根组件，提供只读主题状态
 */
export const ThemeProvider = ({ children }) => {
  // 初始化时应用主题
  useEffect(() => {
    applyTheme(CURRENT_THEME);
  }, []);

  // 获取当前主题配置
  const themeConfig = useMemo(() => {
    return themes[CURRENT_THEME] || themes.classic;
  }, []);

  // 判断是否为深色主题
  const isDarkTheme = useMemo(() => {
    return CURRENT_THEME === THEMES.MODERN_DARK;
  }, []);

  // 判断是否为经典主题
  const isClassicTheme = useMemo(() => {
    return CURRENT_THEME === THEMES.CLASSIC_BLUE;
  }, []);

  // 上下文值（只读）
  const contextValue = useMemo(() => ({
    // 状态
    currentTheme: CURRENT_THEME,
    themeConfig,
    isDarkTheme,
    isClassicTheme,
    
    // 常量
    THEMES,
  }), [themeConfig, isDarkTheme, isClassicTheme]);

  return (
    <ThemeContext.Provider value={contextValue}>
      {children}
    </ThemeContext.Provider>
  );
};

export default ThemeProvider;
